import {toggle} from 'opticks/lib/optimizely'
import {AccessControlState} from 'accessControl/types'
import {hasPlusTier} from '../../auth/modules/selectors'
import {
  getCognitoUserTierFromCookie,
  getUserTierFromCookie
} from '../../auth/business/persistData'
import {HIDDEN_CUG_VALUES, INIT_VALUE} from './constants'
import {USER_TIERS} from '../../offer/business/privateDeals'

export type AccessControlStateType = {
  accessControl: AccessControlState
}

/**
 * Returns if the accessControl was initiated or not
 * used to prevent multiple ACL calls
 */
export const getAccessControlInitiated = ({
  accessControl
}: AccessControlStateType) => accessControl.action !== INIT_VALUE

/**
 * Check if the cug should be hidden.
 * @param state - state with accessControl
 */
export const isCugHidden = (state: {accessControl: AccessControlState}) => {
  const userTierFromCookie = toggle(
    'f54ef0b3-cognito-auth',
    getUserTierFromCookie(),
    getCognitoUserTierFromCookie()
  ) as USER_TIERS[] | []
  const isMemberPlusUser = hasPlusTier(userTierFromCookie)

  const hasHiddenAction = HIDDEN_CUG_VALUES.has(state.accessControl?.action)

  return hasHiddenAction && !isMemberPlusUser
}
